export default __webpack_public_path__ + "/dist/images/audience-icon.fc3545bc15dcfe19a2eb27654dca9e64.svg";